import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, unref as _unref, mergeProps as _mergeProps, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = {
  key: 1,
  class: "width-50"
}

import { computed, ref, onMounted, watch } from "vue";
import { GridItem, GridLayout } from "vue3-drr-grid-layout";
import {
  AttributeSchema,
  AttributePositionSchema,
  GridItemData,
  AttributeGridProps,
} from "@/types";
import { attributesStore } from "@/hooks";
import { FlexBox } from "../content";


/**
 * Renders a grid of attributes.
 */
const __default__ = {
  name: "AttributeGrid",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    layout: {},
    editable: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const gridItemLayout = ref<GridItemData[]>([]);
const staticLayout = ref<(AttributeSchema | undefined)[][]>([]);

const attributeLayout = computed(() =>
  gridItemLayout.value.map((pos: GridItemData) => ({
    pos,
    attr: attributesStore.attributes.find(({ key }) => pos.i === key),
  }))
);

/**
 * Resets the layout to match the store.
 *
 * Creates 2 layout objects:
 * - `gridLayout` represents the layout data needed for editing the arrangement.
 * - `staticLayout` represents the ordered attributes to display when not editing.
 *    This second layout is necessary to get around the variable height limitations of the grid library.
 */
function resetLayout(): void {
  let maxY = 0;
  const attributesByY: Record<number, string[]> = {};

  gridItemLayout.value = props.layout.positions.map(
    (pos: AttributePositionSchema) => {
      maxY = Math.max(pos.y, maxY);

      if (!attributesByY[pos.y]) attributesByY[pos.y] = [];

      if (pos.x === 0) {
        attributesByY[pos.y] = [pos.key, attributesByY[pos.y][1]];
      } else {
        attributesByY[pos.y] = [attributesByY[pos.y][0], pos.key];
      }

      return {
        i: pos.key,
        x: pos.x,
        y: pos.y,
        w: pos.width,
        h: pos.height,
      };
    }
  );

  staticLayout.value = Array.from(Array(maxY + 1)).map(
    (_, idx) =>
      attributesByY[idx]?.map((key) =>
        attributesStore.attributes.find((attr) => attr.key === key)
      ) || []
  );
}

/**
 * Called when an attribute is moved.
 */
function handleMoveEvent(i: string, x: number, y: number) {
  const position = props.layout.positions.find(
    ({ key }: AttributePositionSchema) => key === i
  );

  if (!position) return;

  position.x = x;
  position.y = y;
}

/**
 * Called when an attribute is resized.
 */
function handleResizeEvent(i: string, height: number, width: number) {
  const position = props.layout.positions.find(
    ({ key }: AttributePositionSchema) => key === i
  );

  if (!position) return;

  position.height = height;
  position.width = width;
}

onMounted(() => resetLayout());

watch(
  () => props.layout.positions.length,
  () => resetLayout()
);

return (_ctx: any,_cache: any) => {
  return (_ctx.editable)
    ? (_openBlock(), _createBlock(_unref(GridLayout), {
        key: 0,
        layout: gridItemLayout.value,
        "is-draggable": true,
        "is-resizable": false,
        margin: [20, 20],
        "col-num": 2,
        "row-height": 100,
        "vertical-compact": false
      }, {
        default: _withCtx(({ gridItemProps }) => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(attributeLayout.value, ({ attr, pos }) => {
            return (_openBlock(), _createBlock(_unref(GridItem), _mergeProps(gridItemProps, {
              key: pos.i,
              x: pos.x,
              y: pos.y,
              w: pos.w,
              h: pos.h,
              i: pos.i,
              "is-draggable": !!attr,
              "is-resizable": false,
              onMoved: handleMoveEvent,
              onResized: handleResizeEvent
            }), {
              default: _withCtx(() => [
                _renderSlot(_ctx.$slots, "item", { attribute: attr })
              ]),
              _: 2
            }, 1040, ["x", "y", "w", "h", "i", "is-draggable"]))
          }), 128))
        ]),
        _: 3
      }, 8, ["layout"]))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(staticLayout.value, (attrs, y) => {
          return (_openBlock(), _createBlock(_unref(FlexBox), {
            key: y,
            "full-width": "",
            justify: "between"
          }, {
            default: _withCtx(() => [
              (attrs[0])
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(attrs[1] ? 'width-50' : 'width-100')
                  }, [
                    _renderSlot(_ctx.$slots, "item", {
                      attribute: attrs[0]
                    })
                  ], 2))
                : _createCommentVNode("", true),
              (attrs[1])
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _renderSlot(_ctx.$slots, "item", {
                      attribute: attrs[1]
                    })
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]))
}
}

})